import caudalimetro1 from '../caudalimetroddegases/caudalimetro1.png'


const caudalimetroImages = [
    caudalimetro1,
]

export default caudalimetroImages